import React__default from 'react';
import { C as ChannelProvider } from './ChannelProvider-5dcbee7b.js';
import ChannelUI from './Channel/components/ChannelUI.js';
import './UserProfileContext-f3f446d2.js';
import 'prop-types';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import './const-72f012b6.js';
import './index-ccef08fe.js';
import './index-6add7940.js';
import './topics-eb548880.js';
import './index-579ca9d7.js';
import './utils/message/getOutgoingMessageState.js';
import './compareIds-2e50e905.js';
import '@sendbird/chat/groupChannel';
import './uuid-717930b4.js';
import '@sendbird/chat/message';
import './consts-fa6ab3c0.js';
import './resolvedReplyType-9d00a3db.js';
import './index-2cfab646.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './ui/Icon.js';
import './index-6420013c.js';
import './ui/Loader.js';
import './ui/ConnectionStatus.js';
import './Channel/components/ChannelHeader.js';
import './utils-b571dc44.js';
import './ui/IconButton.js';
import './ui/ChannelAvatar.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './utils-7f5e872b.js';
import './MediaQueryContext-d6110905.js';
import './utils-e0c7329c.js';
import './Channel/components/MessageList.js';
import './Channel/components/Message.js';
import './Channel/components/SuggestedMentionList.js';
import './const-3a34a127.js';
import './ThreadProvider-cf357120.js';
import './Thread/context/types.js';
import '@sendbird/chat';
import './ui/DateSeparator.js';
import './color-91e43dce.js';
import './ui/MessageInput.js';
import './ui/Button.js';
import 'dompurify';
import './consts-b4cb83cf.js';
import './consts-7693b8d3.js';
import './consts-9469111b.js';
import './tokenize-c718324d.js';
import './index.module-4f1cd64e.js';
import './ui/MessageContent.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './index-ac0b2d20.js';
import './index-f879f6ef.js';
import './index-ad50e2c0.js';
import './ui/MessageItemMenu.js';
import './ui/ContextMenu.js';
import 'react-dom';
import './ui/SortByRow.js';
import './types-95cfd227.js';
import './ui/MessageItemReactionMenu.js';
import './ui/ReactionButton.js';
import './useLongPress-12280c78.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/BottomSheet.js';
import './index-a9101009.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './ui/AdminMessage.js';
import './ui/TextMessageItemBody.js';
import './index-a2bb2783.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './ui/FileMessageItemBody.js';
import './ui/TextButton.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/OGMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import './ui/QuoteMessage.js';
import './index-86294a68.js';
import './ui/ThreadReplies.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './index-fa5b2b8c.js';
import './VoiceRecorder/context.js';
import './ui/Modal.js';
import './ui/PlaybackTime.js';
import './Channel/components/FileViewer.js';
import './Channel/components/RemoveMessageModal.js';
import './index-dd5a8777.js';
import './useDirtyGetMentions-dffd4046.js';
import './Channel/components/UnreadCount.js';
import './Channel/components/FrozenNotification.js';
import './Channel/components/TypingIndicator.js';
import './Channel/components/MessageInput.js';
import './ui/QuoteMessageInput.js';
import './VoiceMessageInputWrapper-43163d7f.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './index-090cbf21.js';
var Channel = function Channel(props) {
  return /*#__PURE__*/React__default.createElement(ChannelProvider, {
    channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl,
    isReactionEnabled: props === null || props === void 0 ? void 0 : props.isReactionEnabled,
    isMessageGroupingEnabled: props === null || props === void 0 ? void 0 : props.isMessageGroupingEnabled,
    showSearchIcon: props === null || props === void 0 ? void 0 : props.showSearchIcon,
    animatedMessage: props === null || props === void 0 ? void 0 : props.animatedMessage,
    highlightedMessage: props === null || props === void 0 ? void 0 : props.highlightedMessage,
    startingPoint: props === null || props === void 0 ? void 0 : props.startingPoint,
    onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage,
    onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage,
    onBeforeUpdateUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeUpdateUserMessage,
    onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick,
    onSearchClick: props === null || props === void 0 ? void 0 : props.onSearchClick,
    onBackClick: props === null || props === void 0 ? void 0 : props.onBackClick,
    replyType: props === null || props === void 0 ? void 0 : props.replyType,
    threadReplySelectType: props === null || props === void 0 ? void 0 : props.threadReplySelectType,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile,
    filterMessageList: props === null || props === void 0 ? void 0 : props.filterMessageList,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    disableMarkAsRead: props === null || props === void 0 ? void 0 : props.disableMarkAsRead,
    onReplyInThread: props === null || props === void 0 ? void 0 : props.onReplyInThread,
    onQuoteMessageClick: props === null || props === void 0 ? void 0 : props.onQuoteMessageClick,
    onMessageAnimated: props === null || props === void 0 ? void 0 : props.onMessageAnimated,
    onMessageHighlighted: props === null || props === void 0 ? void 0 : props.onMessageHighlighted
  }, /*#__PURE__*/React__default.createElement(ChannelUI, {
    isLoading: props === null || props === void 0 ? void 0 : props.isLoading,
    renderPlaceholderLoader: props === null || props === void 0 ? void 0 : props.renderPlaceholderLoader,
    renderPlaceholderInvalid: props === null || props === void 0 ? void 0 : props.renderPlaceholderInvalid,
    renderPlaceholderEmpty: props === null || props === void 0 ? void 0 : props.renderPlaceholderEmpty,
    renderChannelHeader: props === null || props === void 0 ? void 0 : props.renderChannelHeader,
    renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage,
    renderMessageInput: props === null || props === void 0 ? void 0 : props.renderMessageInput,
    renderTypingIndicator: props === null || props === void 0 ? void 0 : props.renderTypingIndicator,
    renderCustomSeparator: props === null || props === void 0 ? void 0 : props.renderCustomSeparator,
    renderFileUploadIcon: props === null || props === void 0 ? void 0 : props.renderFileUploadIcon,
    renderVoiceMessageIcon: props === null || props === void 0 ? void 0 : props.renderVoiceMessageIcon,
    renderSendMessageIcon: props === null || props === void 0 ? void 0 : props.renderSendMessageIcon
  }));
};
export { Channel as default };